import { loginActions } from "./LoginActions";

const initState = {
    phoneNumber: null,
    code: null,
    token: null,
    exp: null,
    step: 1,
    sendAgainDisable: false,
    sendAgainShown: false,
    canSubmitPhoneNumber: true
};

export default function teacherListPageReducer(state = initState, action) {
    switch (action.type) {
        case loginActions.setToken:
            return setToken(state, action);
        case loginActions.setPhoneNumber:
            return setPhoneNumber(state, action);
        case loginActions.changeStep:
            return changeStep(state, action);
        case loginActions.hideSendAgain:
            return changeSendAgainVisibilityStatus(state, false);
        case loginActions.showSendAgain:
            return changeSendAgainVisibilityStatus(state, true);
        case loginActions.disableSendAgain:
            return changeSendAgainStatus(state, true);
        case loginActions.enableSendAgain:
            return changeSendAgainStatus(state, false);
        case loginActions.setCanSubmitPhoneNumber:
            return setCanSubmitPhoneNumber(state, action);
        default:
            return state;
    }
}

function setCanSubmitPhoneNumber(state, { payload }) {
    return {
        ...state,
        canSubmitPhoneNumber: payload
    };
}

function setToken(state, { payload }) {
    return {
        ...state,
        token: payload.token,
        exp: payload.exp
    };
}

function setPhoneNumber(state, { payload }) {
    return {
        ...state,
        phoneNumber: payload.phoneNumber
    };
}

function changeStep(state, { payload }) {
    return {
        ...state,
        step: payload.step
    };
}

function changeSendAgainVisibilityStatus(state, status) {
    return {
        ...state,
        sendAgainShown: status
    };
}

function changeSendAgainStatus(state, status) {
    return {
        ...state,
        sendAgainShown: status
    };
}
